import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'

import { Snackbar } from '@/ui/Snackbar'
import { globalSnackbarAtom } from '@/recoil/atoms'

import { useGlobalSnackbarStore } from '@/stores/globalSnackbar'

export const GlobalSnackbar = () => {
    const [mounted, setMounted] = useState(false)
    const [show, setShow] = useState(false)
    const { initialiseGlobalSnackbar } = useGlobalSnackbarStore()

    const globalSnackbar = useRecoilValue(globalSnackbarAtom)

    useEffect(() => setMounted(true), [])

    // Initialise the setter of show for the global snackbar
    useEffect(() => {
        initialiseGlobalSnackbar(setShow)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mounted])

    return (
        <Snackbar
            show={show}
            setShow={setShow}
            variant={globalSnackbar.variant}
        >
            {globalSnackbar.text}
        </Snackbar>
    )
}
